// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vTffz8o0OD6vJR {
  width: 511px;
  height: 40px;
  margin-bottom: var(--ds-space-0, 0px);
  font-size: 35px;
  font-weight: var(--ds-font-weight-bold, bold);
  white-space: nowrap;
}
@media only screen and (max-width: 750px) {
  .vTffz8o0OD6vJR {
    width: 90%;
    height: 100%;
    white-space: normal;
  }
}
.dupsv1_YqZcpFz {
  width: 511px;
  height: 40px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-bottom: 30px;
  font-size: 14px;
  line-height: 20px;
}
@media only screen and (max-width: 750px) {
  .dupsv1_YqZcpFz {
    width: 90%;
    height: 100%;
    padding-top: var(--ds-space-150, 10px);
  }
}
.lGOIRtNGU5B2Co {
  z-index: 0;
  width: 400px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-top: 150px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-left: 20%;
}
@media only screen and (max-width: 750px) {
  .lGOIRtNGU5B2Co {
    width: 95%;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    padding-left: 46px;
  }
}
.VqH8CArQP6o3xJ {
  padding: var(--ds-space-150, 10px) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
@media only screen and (max-width: 750px) {
  .VqH8CArQP6o3xJ {
    padding: var(--ds-space-150, 10px) var(--ds-space-500, 40px) var(--ds-space-0, 0) var(--ds-space-0, 0);
    text-align: left;
  }
}
.eUlXbb0N4KZDMv {
  width: 100%;
}
@media only screen and (max-width: 750px) {
  .ow8zAtkkowEzVO {
    margin-right: var(--ds-space-500, 40px);
  }
}
.I2VZPpzJgm3qwu {
  margin-top: var(--ds-space-200, 15px);
}
.I2VZPpzJgm3qwu p {
  padding-bottom: var(--ds-space-150, 10px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `vTffz8o0OD6vJR`,
	"subtitle": `dupsv1_YqZcpFz`,
	"body": `lGOIRtNGU5B2Co`,
	"loggedOutPageLoginButton": `VqH8CArQP6o3xJ`,
	"loggedOutPageSignupButtonWrapper": `eUlXbb0N4KZDMv`,
	"loggedOutPageSignupButton": `ow8zAtkkowEzVO`,
	"requestStorageAccessWrapper": `I2VZPpzJgm3qwu`
};
export default ___CSS_LOADER_EXPORT___;
